import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="radio-buttons"
export default class extends Controller {
  static targets = ["button", "input"]
  
  connect() {
    // Инициализация состояния кнопок при загрузке
    this.updateButtonStates()
  }
  
  // Обработка клика по кнопке
  select(event) {
    const clickedButton = event.currentTarget
    const radioInput = clickedButton.previousElementSibling
    
    if (radioInput && radioInput.type === 'radio') {
      // Снимаем активное состояние со всех кнопок в группе
      this.buttonTargets.forEach(button => {
        button.classList.remove('active')
      })
      
      // Активируем выбранную кнопку
      clickedButton.classList.add('active')
      
      // Устанавливаем checked для radio input
      radioInput.checked = true
      
      // Диспатчим событие change для интеграции с формами
      radioInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }
  
  // Обновление состояния кнопок (для инициализации)
  updateButtonStates() {
    this.inputTargets.forEach(input => {
      const label = input.nextElementSibling
      if (input.checked && label) {
        label.classList.add('active')
      }
    })
  }
}
